import { Component, OnInit } from '@angular/core';
import { HomeService } from '../../services/home.service';
import { CommonModule, Location } from '@angular/common';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-stock-detail',
  templateUrl: './stock-detail.component.html',
  styleUrls: ['./stock-detail.component.scss', '../../../app.component.scss']
})
export class StockDetailComponent implements OnInit{
  constructor(private route: ActivatedRoute, public location: Location, public homeService: HomeService){}

  public stores: any;
  public stocks: any[] = [];
  public stockId: string = "";
  public storeId: string = "";
  public stockDetails: any = [];
  storeName: string;
  stockNames: string[] = ['active_stocks', 'consumed_stocks', 'missing_stocks', 'expired_stocks','', 'low_stocks'];
  imagePaths: string[] = [
    '../../../../assets/images/storelist/implants.svg',
    '../../../../assets/images/storelist/consumed.svg',
    '../../../../assets/images/storelist/missingstock.svg',
    '../../../../assets/images/storelist/expired.svg',
    '../../../../assets/images/storelist/expiring.svg',
     '../../../../assets/images/storelist/expiring.svg',
    
  ];
 
  ngOnInit(): void {
    this.getStockDetails(); 
    this.getStoreName(this.stockId); 
  }    

  goBack(){
    this.location.back();
  }
 
  getStockDetails() {  
    this.route.queryParams.subscribe(params => {
      const stockIdFromParams = params['id'];  
      if (stockIdFromParams) { 
        this.stockId = stockIdFromParams; 
        this.homeService.getStockDetails(stockIdFromParams).subscribe((res: any) => {
          if (res.success && res.data) {
            this.stockDetails = res.data;
            this.initializeStocks();
          }
          console.log("res", res);  
        });  
      } else {
        console.error('No stock ID provided in query parameters');
      }
    });
  }

  initializeStocks(): void {
    this.stocks = [ 
      { name: "Active Implants", navigate: `/home/stocks/stores/${this.stockId}/implants/active`},
      { name: "Consumed Implants", navigate: `/home/stocks/stores/${this.stockId}/implants/consumed`},
      { name: "Missing Implants", navigate: `/home/stocks/stores/${this.stockId}/implants/missing`},
      { name: "Expired Implants", navigate: `/home/stocks/stores/${this.stockId}/implants/expired`}, 
      { name: "Expiring in 30days", navigate: `/home/stocks/stores/${this.stockId}/implants/expiring`},
      { name: "Low Stocks", navigate: `/home/stocks/stores/${this.stockId}/implants/low_stocks`}
      
      
    ];
  }

  getStoreName(stockId: string): void{
    this.homeService.getStoreName(stockId).subscribe( 
      (response: any) => {
        this.storeName = response.data.name;
      },
      (error) => {
        console.error('Error fetching store name:', error);
      }
    );
  }
}
